const Shopcard = [
    {   
        id : 1,
        name: "God of War",
        price: "₹1499.0",
        totalprice : "1948.0",
        imgurl: "https://upload.wikimedia.org/wikipedia/en/e/ee/God_of_War_Ragnar%C3%B6k_cover.jpg",
        description: "In God of War, player control Kratos, a Spartan warrior who is sent by the Greek Gods to kill Ares, the God of War.",
        gamelink : "https://www.playstation.com/en-in/games/god-of-war-ps4/"
    },
    {
        id : 2,
        name: "GTA 5",
        price: "₹2497.0",
        totalprice : "3246.1",
        imgurl: "https://upload.wikimedia.org/wikipedia/en/a/a5/Grand_Theft_Auto_V.png",
        description: "Grand Theft Auto V is a 2013 action-adventure game developed by Rockstar North and published by Rockstar Games.",
        gamelink : "https://store.rockstargames.com/game/buy-gta-v?_gl=1*107sssu*_ga*ODkyMzAxOTI4LjE3MjY5NDMwODk.*_ga_PJQ2JYZDQC*MTcyNjk0MzA4OC4xLjEuMTcyNjk0MzExOS4wLjAuMA.."
    },
    {   
        id : 3,
        name: "Black Myth Wukong",
        price: "₹3019.3",
        totalprice : "4099.0",
        imgurl: "https://upload.wikimedia.org/wikipedia/en/a/a6/Black_Myth_Wukong_cover_art.jpg",
        description: "Black Myth: Wukong is an upcoming action role-playing game developed by Game Science.",
        gamelink : "https://store.steampowered.com/app/2358720/Black_Myth_Wukong/"
    },
    {   
        id : 4,
        name:"Red Dead Redemption 2",
        price: "₹2739.3",
        totalprice : "3699.0",
        imgurl:"https://upload.wikimedia.org/wikipedia/en/4/44/Red_Dead_Redemption_II.jpg",
        description: "Red Dead Redemption 2 is a 2018 action-adventure game developed and published by Rockstar Games.",
        gamelink : "https://store.steampowered.com/app/1174180/Red_Dead_Redemption_2/"
    },
    {   
        id : 5,
        name:"Far Cry 6",
        price:"₹2999.0",
        totalprice : "3999.0",
        imgurl:"https://upload.wikimedia.org/wikipedia/en/3/35/Far_cry_6_cover.jpg",
        description: "Far Cry 6 is an upcoming action role-playing video game developed by Ubisoft Toronto and published by Ubisoft.",
        gamelink : "https://store.steampowered.com/app/1659040/Far_Cry_6/"
    }

]

const Detail =[
    {}
]
export { Shopcard ,Detail };